import React from 'react';
import styled from 'styled-components';
import Select from '../../dev/Select';
import { connect } from 'react-redux'
import countryOptions from '../../dev/countryOptions'
import Title from './Title'

const CountrySearch = (props) => {
    const { country, countrySelect, text } = props
    return (
        <CountryWrap>
            <Title>{text}</Title>
            <StyledSelect
                value={country}
                onChange={countrySelect}
                options={countryOptions}
                placeholder={countryOptions.find(i => i.value === country).label}
                id='Country'
            />
        </CountryWrap>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(CountrySearch);
const CountryWrap = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    @media (max-width: 900px) {
        margin-bottom: 10px;
    }
`;
const StyledSelect = styled(Select)`
    z-index: 5001;
    @media (max-width: 900px) {
        width: 100%;
    }
`


// WEBPACK FOOTER //
// ./src/Ranking/RankCondition/CountrySearch.js